const MissingComponent = (): JSX.Element => {
  return <></>;
};

export default MissingComponent;
